import {
  FormlyAttributes,
  FormlyField,
  FormlyForm,
  FormlyValidationMessage,
} from '@ngx-formly/core';

/**
 * Shared standalone Formly imports for custom field and form components.
 */
export const MSS_FORMLY_IMPORTS = [
  FormlyAttributes,
  FormlyField,
  FormlyForm,
  FormlyValidationMessage,
] as const;
